import { useSyncExternalStore } from 'react'
import { liveTuneStore } from '../lib/liveTuneStore'

/**
 * useLiveTune — React hook returning the current live-tune state.
 *
 * Components re-render when any field changes. That's fine at the
 * small-scale of live-mode components (a handful of mounts); if we ever
 * need per-slice selectors we can add them later.
 */
export function useLiveTune() {
  return useSyncExternalStore(liveTuneStore.subscribe, liveTuneStore.getState, liveTuneStore.getState)
}

/**
 * useCameraCageGizmoVisible — dev-only "show the camera cage gizmo" flag.
 * Lives outside `state` in liveTuneStore (ephemeral, never persisted); this
 * hook subscribes to the same store so a component re-renders when it flips.
 */
export function useCameraCageGizmoVisible() {
  return useSyncExternalStore(liveTuneStore.subscribe, liveTuneStore.getCageGizmoVisible, liveTuneStore.getCageGizmoVisible)
}
